import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/BasePage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { BaseForm } from "@/components/BaseForm";
export const BasePage = observer(() => {
    const navigate = useNavigate();
    const { baseId } = useParams();
    const { singleBaseStore: store, authStore: { userRole }, } = getRootStore();
    const { base, loading } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(baseId);
        return () => {
            store.clearBaseData();
        };
    }, [baseId]);
    const handleBack = () => {
        navigate("/bases");
    };
    const handleSave = async (values) => {
        const isNewBase = !base;
        store.saveBase(values).then((savedBase) => {
            if (savedBase) {
                if (isNewBase) {
                    message.success("База успешно создана");
                    navigate(`/bases/${savedBase.id}`);
                }
                else {
                    message.success("База успешно обновлена");
                }
            }
        });
    };
    const handleDeleteBase = () => {
        if (!base)
            return;
        Modal.confirm({
            title: "Удаление базы",
            content: "Вы уверены, что хотите удалить эту базу?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteBase(base.id);
                message.success("База успешно удалена");
                navigate("/bases");
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(BaseForm, { base: base, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: canDelete && base && (_jsx(Button, { type: "default", danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteBase, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })] }));
});
export default BasePage;
